module.exports = __webpack_public_path__ + "media/images/x_button_12x12-5970c6ff206b1d24d966c2c97684fc7f.png";